/** Visible-by-default columns, per the maquette (Search Terms screen). */
export const DEFAULT_VISIBLE_COLUMNS = [
  'search_term',
  'monthly_search_volumes',
  'top5_compet_total',
  'visibility_rate',
  'blended_ctr',
  'clicks_split',
  'ad_cost',
  'opportunity',
];

export const ECOMMERCE_ONLY = ['paid_roas', 'paid_aov'];
export const LEAD_ONLY = ['paid_cpa', 'ad_cpc'];

/** The maquette's columns, plus Paid CPA for Lead workspaces or Paid ROAS for eCommerce ones (recette 2026-10-22). */
export const defaultVisibleColumns = (isLead: boolean): string[] => [...DEFAULT_VISIBLE_COLUMNS, isLead ? 'paid_cpa' : 'paid_roas'];

const baseField = (field: string) => field.replace(/_(compare|diff)$/, '');

/** Drop the other workspace type's columns. Applied after useBuildColumns so its hook loop stays constant. */
export function columnsForTemplate<T extends { field: string }>(columns: T[], isLead: boolean): T[] {
  const hidden = isLead ? ECOMMERCE_ONLY : LEAD_ONLY;
  return columns.filter((column) => !hidden.includes(baseField(column.field)));
}

/** Null means "no scraping data" (render nothing); 0 is a real 0% (100% competitors). */
export const isEmptyValue = (value: unknown): boolean => value === null || value === undefined;

export const COLUMN_GROUPS: { groupId: 'Visibility' | 'Traffic' | 'Performance'; fields: string[] }[] = [
  {
    groupId: 'Visibility',
    fields: [
      'monthly_search_volumes',
      'top5_compet_total',
      'top5_search_rate',
      'top5_shopping_rate',
      'top5_organic_rate',
      'paid_search_share',
      'paid_shopping_share',
      'organic_share',
      'visibility_rate',
      'paid_search_visibility_rate',
      'paid_shopping_visibility_rate',
      'organic_visibility_rate',
      'avg_seo_position',
    ],
  },
  {
    groupId: 'Traffic',
    fields: ['blended_ctr', 'organic_ctr', 'paid_search_ctr', 'paid_shopping_ctr', 'clicks_split'],
  },
  {
    groupId: 'Performance',
    fields: [
      'ad_cost',
      'paid_roas',
      'paid_aov',
      'paid_cpa',
      'ad_cpc',
      'conversions',
      'revenue',
      'cvr',
    ],
  },
];
